import { IEnvironment } from './environment.interface';
import { EnvironmentEnum } from './environment.enum';

export const environment: IEnvironment = {
  env: EnvironmentEnum.production,
  production: true,
  gatewayUrl: 'https://gateway.2go.com',
  baseDomain: '2go.com',
  domain: '2go.com',
  debugMode: false,
  version: '10.155.1', // set by prebuild.js
  webAppURL: 'https://web.2go.com',
  raygunAPIKey: 'ekurz5SE2Chq4ndqhfWRww',
  googleClientId:
    '687485459290-tflgq6ece37l2j6ll4csoaro8k5ucb8v.apps.googleusercontent.com',
  facebookAppId: '288818037991316',
  appleClientId: 'com.invoice2go.plus.web',
  segmentWriteKey: 'zGjdj3Q2Px3IsGeOhcvj6914pmwXh8ta',
  redirectServiceUrl: 'https://redirect.2go.com',
};
